import { Button } from 'components/common';
import { useNavigateBack } from 'hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams, useSearchParams } from 'react-router-dom';
import { ApplicationFormPageEnum } from '../types';
import { dependantsQuestions } from './questions';
import { IDependantsForm } from './types';
import { getCurrentRoute } from 'utils/location';
import { useApplicationInProgressById } from 'queries/applications/useApplicationInProgressById';
import { useMutation } from '@tanstack/react-query';
import { applicationFormApi } from 'api/applicationForm';
import { parseApplicationInProgress } from '../helpers';
import { useEffect } from 'react';
import { FormNumberField } from 'components/common/FormNumberField';

export const Dependants = () => {
  const intl = useIntl();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigateBack = useNavigateBack();
  const { id: applicationId = '' } = useParams();
  const currentRoute = getCurrentRoute();
  const { mutate: patchApplicationInProgress } = useMutation(applicationFormApi.patchApplicationInProgress);
  const { data: applicationInProgress } = useApplicationInProgressById(applicationId);
  const formattedResponse =
    applicationInProgress?.[currentRoute] && parseApplicationInProgress(applicationInProgress[currentRoute]);

  const form = useForm<IDependantsForm>({
    defaultValues: {
      dependantsOver13: '',
      dependantsUnder13: '',
    },
  });

  useEffect(() => {
    if (formattedResponse) form.reset(formattedResponse);
  }, [applicationInProgress]);

  const submitFormHandler = async (formData: IDependantsForm) => {
    const questions = Object.entries(formData).map(([key, answer]) => ({
      question: intl.formatMessage({ id: dependantsQuestions[key].labelKey }),
      key,
      answer,
    }));

    await patchApplicationInProgress({ questions, currentRoute, applicationId });
    searchParams.set('section', ApplicationFormPageEnum.HOUSEHOLD_SPENDINGS);

    setSearchParams(searchParams);
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(submitFormHandler)}>
        <div>
          <FormattedMessage id={dependantsQuestions.dependantsUnder13.labelKey} tagName={'h4'} />
          <FormattedMessage id={dependantsQuestions.dependantsUnder13.explanationKey} tagName={'p'} />
          <FormNumberField
            name={'dependantsUnder13'}
            rules={{ min: 0, required: intl.formatMessage({ id: 'common.error.requiredField' }) }}
          />
        </div>

        <div className={'mt-8'}>
          <FormattedMessage id={dependantsQuestions.dependantsOver13.labelKey} tagName={'h4'} />
          <FormattedMessage id={dependantsQuestions.dependantsOver13.explanationKey} tagName={'p'} />
          <FormNumberField
            name={'dependantsOver13'}
            rules={{ min: 0, required: intl.formatMessage({ id: 'common.error.requiredField' }) }}
          />
        </div>

        <div className={'mt-8 flex justify-between'}>
          <Button variant={'outlined'} onClick={navigateBack}>
            <FormattedMessage id={'cta.back'} />
          </Button>

          <Button variant={'contained'} type={'submit'}>
            <FormattedMessage id={'cta.continue'} />
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};
